import { defaultState } from '../reducer';

export default state => state.explorer || defaultState;
